module.exports = "/_next/static/images/OgSegmentIndustryFinancialServices-d16cb50b3b0235d9c9901ee16605ae22.png";